import classes from "./HomepageCollectionSkeleton.module.scss";
import DefaultCompactInventoryCard from "./DefaultCompactInventoryCard";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";

const HomepageCollectionSkeleton = ({ title, id, subTitle, isDesktop }: any) => {
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();
  return (
    <>
      <div
        className={formatClassNames(
          isWhitelabel ? classes.skeletonContainerOuterWhitelabel : classes.skeletonContainerOuter,
          isDesktop && classes.desktop,
        )}
        id={id}
      >
        <div className={isDesktop ? classes.titleBarDesktop : classes.titleBar}>
          <h2 className={classes.sectionTitle}>{t(title)}</h2>
          {subTitle && <div className={classes.sectionSubTitle}>{t(subTitle)}</div>}
        </div>
        <div
          className={formatClassNames(
            classes.outerContainerDefault,
            isDesktop && classes.desktop,
            isWhitelabel && classes.whitelabel,
          )}
        >
          {!isWhitelabel && (
            <>
              <div className={classes.spacing} />

              <div
                className={formatClassNames(
                  classes.horizontalScroll,
                  isDesktop && classes.desktop,
                  isWhitelabel && classes.whitelabel,
                )}
              >
                {Array.from({ length: 9 }, (_, index) => (
                  <div key={index} className={classes.pillsDefault} />
                ))}
              </div>
            </>
          )}
          <div className={formatClassNames(classes.horizontalScroll, isDesktop && classes.desktop)}>
            {Array.from({ length: 10 }, (_, index) => (
              <DefaultCompactInventoryCard key={index} />
            ))}
          </div>
        </div>
      </div>
      {!isDesktop && <div className={classes.bottomBorder} />}
    </>
  );
};

export default wrapperHOC(HomepageCollectionSkeleton, {
  componentName: "HomepageCollectionSkeleton-Home",
  showForChina: true,
});
